var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcLight"},[_c('h1',[_vm._v("Import Test")]),_c('div',{staticClass:"MatcDialog MatchImportDialog MatcPadding"},[_c('ImportDialog',{ref:"importDialog"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }